import { render, staticRenderFns } from "./UserRecord.vue?vue&type=template&id=ec59ee9e"
import script from "./UserRecord.vue?vue&type=script&lang=js"
export * from "./UserRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports